import { useCallback, useMemo } from "react";
import { useFolderTreeRenameMode } from "./useFolderTreeRenameMode.js";
import { useFolderTree } from "../../contexts/folderTree.js";
import { useComposedRenameClose } from "../compose/useComposedRenameClose.js";
function useTreeRenameModeHandlers() {
    const { onRenamePersist } = useFolderTree();
    const enabled = !!onRenamePersist;
    const { handleRenameClick, handleRenameCancel, handleNodePressF2 } = useFolderTreeRenameMode();
    const handleRenameClose = useComposedRenameClose(handleRenameCancel);
    const resolveBuiltInToolbarAction = useCallback((action, _buttonId)=>{
        if (!enabled || action !== "rename") {
            return {};
        }
        return {
            onClick: handleRenameClick,
            onCancel: handleRenameCancel
        };
    }, [
        enabled,
        handleRenameCancel,
        handleRenameClick
    ]);
    return useMemo(()=>{
        if (!enabled) {
            return undefined;
        }
        return {
            onRenameClose: handleRenameClose,
            onNodePressF2: handleNodePressF2,
            resolveBuiltInToolbarAction
        };
    }, [
        enabled,
        handleRenameClose,
        handleNodePressF2,
        resolveBuiltInToolbarAction
    ]);
}
export { useTreeRenameModeHandlers };
